'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = require('@progress/kendo-base-components-vue-wrapper');

var _KendoDataSourceBase = require('../KendoDataSourceBase');

var _KendoDataSourceBase2 = _interopRequireDefault(_KendoDataSourceBase);

var _TreeListDataSourceProps = require('./TreeListDataSourceProps');

var _TreeListDataSourceProps2 = _interopRequireDefault(_TreeListDataSourceProps);

var _Schema = require('./Schema');

var _Schema2 = _interopRequireDefault(_Schema);

var _Filter = require('../KendoDataSourceBase/Filter');

var _Filter2 = _interopRequireDefault(_Filter);

var _Group = require('../KendoDataSourceBase/Group');

var _Group2 = _interopRequireDefault(_Group);

var _Sort = require('../KendoDataSourceBase/Sort');

var _Sort2 = _interopRequireDefault(_Sort);

var _Transport = require('../KendoDataSourceBase/Transport');

var _Transport2 = _interopRequireDefault(_Transport);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: _TreeListDataSourceProps2.default,
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _KendoDataSourceBase2.default, _Filter2.default, _Group2.default, _Schema2.default, _Sort2.default, _Transport2.default],
    mounted: function mounted() {
        this.kendoDataSource = new kendo.data.TreeListDataSource(this.widgetOptions);
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return this.kendoDataSource || new kendo.dataTreeListDataSource(this.widgetOptions);
        }
    }
};